import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { formatDate } from '@/utils';
import { FeedbackStatus, IFeedback } from '@/models/feedback.model';
import { getDeleteColumn, getManagerColumn, getStatusTypeOptions } from '@/modules/Feedbacks';
import { Select, TextTruncate, Tooltip } from '@/ui';

type TGetPartnersTableColumns = {
  t: TFunction;
  onChangeStatus?: (data: { id: string; status: FeedbackStatus }) => void;
  onDelete?: (feedback: IFeedback) => void;
};

export const getPotentialPartnersTableColumns = ({
  t,
  onChangeStatus,
  onDelete,
}: TGetPartnersTableColumns): ColumnsType<IFeedback> => [
  {
    title: t('users_list_users_name'),
    dataIndex: 'name',
    key: 'name',
    render: (_, record) => <span>{record?.name}</span>,
  },
  {
    title: t('users_list_users_shop'),
    dataIndex: 'store_title',
    key: 'store_title',
    render: (_, record) => <span>{record?.feedback_info?.title}</span>,
  },
  {
    title: t('users_list_phone_number'),
    dataIndex: 'phone',
    key: 'phone',
    render: (phone) => <span>{phone}</span>,
  },
  // {
  //   title: t('users_list_code'),
  //   dataIndex: 'phone',
  //   key: 'phone',
  //   render: (_, record) => <span>{record?.feedback_info?.organization_tax_code}</span>,
  // },
  {
    title: t('users_list_comment'),
    dataIndex: 'comment',
    key: 'comment',
    render: (comment) => (
      <div>
        <Tooltip title={comment}>
          <TextTruncate text={comment} rows={1} style={{ width: 250 }} />
        </Tooltip>
      </div>
    ),
  },
  {
    title: t('users_list_date'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (created_at) => <span>{created_at ? formatDate(created_at) : '-'}</span>,
  },
  getManagerColumn(t('users_list_manager')),
  {
    title: t('users_list_status'),
    dataIndex: 'status',
    key: 'status',
    render: (_, record) => {
      const handleSelect = (value: FeedbackStatus) => {
        onChangeStatus?.({
          id: record.id,
          status: value,
        });
      };
      return (
        <Select
          value={record.status}
          onChange={handleSelect}
          disabled={!onChangeStatus}
          options={getStatusTypeOptions(t)}
        />
      );
    },
  },
  ...getDeleteColumn(onDelete),
];
